interface PlaceholderProps {
  title: string;
  hint?: string;
}

/** Placeholder for pages not yet migrated; rendered as a 'WIP' card. */
export function Placeholder({ title, hint }: PlaceholderProps) {
  return (
    <div className="rounded-xl border bg-card p-8 text-center">
      <h1 className="text-xl font-semibold">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        {hint ?? "Página pendiente de migrar — se implementará en la fase correspondiente."}
      </p>
    </div>
  );
}
